module.exports = __webpack_public_path__ + "img/CAR-XXX.2262f71b.png";